/**
 * Split path AI getters/setters for the Standard tab draft.
 */

import type {
  VoluumCalculationMethod,
  VoluumPathUpdate,
} from '@trafficpulse/shared';

import {
  TP_OFFERS_CALCULATION_METHOD_KEY,
  TP_OFFERS_LANDERS_AI_KEY,
  TP_PATHS_CALCULATION_METHOD_KEY,
  TP_PATHS_DISTRIBUTION_AI_KEY,
  baseCalculationMethod,
  readTpCalc,
  readTpFlag,
} from './path-ai-read';
import {
  syncPathAutoOptimized,
  syncPathCalculationMethod,
} from './path-ai-voluum-sync';

export {
  TP_OFFERS_CALCULATION_METHOD_KEY,
  TP_OFFERS_LANDERS_AI_KEY,
  TP_PATHS_CALCULATION_METHOD_KEY,
  TP_PATHS_DISTRIBUTION_AI_KEY,
} from './path-ai-read';

export {
  applyTpSplitToVoluumAutomation,
  syncPathAutoOptimized,
  syncPathCalculationMethod,
} from './path-ai-voluum-sync';

export function getPathsDistributionAi(p: VoluumPathUpdate): boolean {
  const v = readTpFlag(p, TP_PATHS_DISTRIBUTION_AI_KEY);
  if (v !== undefined) return v;
  return p.autoOptimized;
}

export function getOffersLandersAi(p: VoluumPathUpdate): boolean {
  const v = readTpFlag(p, TP_OFFERS_LANDERS_AI_KEY);
  if (v !== undefined) return v;
  return p.autoOptimized;
}

export function getPathsCalculationMethod(
  p: VoluumPathUpdate,
): VoluumCalculationMethod {
  return (
    readTpCalc(p, TP_PATHS_CALCULATION_METHOD_KEY) ?? baseCalculationMethod(p)
  );
}

export function getOffersCalculationMethod(
  p: VoluumPathUpdate,
): VoluumCalculationMethod {
  return (
    readTpCalc(p, TP_OFFERS_CALCULATION_METHOD_KEY) ??
    baseCalculationMethod(p)
  );
}

export function setPathsDistributionAi(
  p: VoluumPathUpdate,
  next: boolean,
): void {
  p[TP_PATHS_DISTRIBUTION_AI_KEY] = next;
  syncPathAutoOptimized(p);
  syncPathCalculationMethod(p);
}

export function setOffersLandersAi(p: VoluumPathUpdate, next: boolean): void {
  p[TP_OFFERS_LANDERS_AI_KEY] = next;
  syncPathAutoOptimized(p);
  syncPathCalculationMethod(p);
}

export function setPathsCalculationMethod(
  p: VoluumPathUpdate,
  next: VoluumCalculationMethod,
): void {
  p[TP_PATHS_CALCULATION_METHOD_KEY] = next;
  syncPathCalculationMethod(p);
}

export function setOffersCalculationMethod(
  p: VoluumPathUpdate,
  next: VoluumCalculationMethod,
): void {
  p[TP_OFFERS_CALCULATION_METHOD_KEY] = next;
  syncPathCalculationMethod(p);
}
